import { realEstatesService } from '@/services/realEstates.service'
import { HZ_INVESTOR_ONBOARDING_PATHNAME } from '@/router/constants'

/**
 * Middleware — vérifie que l'utilisateur a au moins un bien enregistré.
 * Si aucun bien : redirige vers l'onboarding "Ajouter un bien".
 * Si au moins un bien : laisse passer au middleware suivant.
 *
 * Ce middleware doit être placé AVANT checkPermission dans la chaîne,
 * pour éviter qu'un utilisateur payant sans bien voie le message
 * "Votre abonnement ne vous permet pas d'effectuer cette action"
 * alors que son abonnement est valide — il n'a juste pas encore de bien.
 */
export default async function checkHasRealEstates({ next }) {
  const count = await realEstatesService.getRealEstateNumber()

  if (count.count > 0) {
    return next()
  }

  return { path: HZ_INVESTOR_ONBOARDING_PATHNAME }
}
